<script setup lang="ts">
import type { VoixModuleOptionsAdministrationInterface } from '@voix/types'
import { useVoixMenus } from '@voix/composables/useVoixMenus'
import { useNuxtApp } from '#imports'

const { $voix } = useNuxtApp()
const allMenus: VoixModuleOptionsAdministrationInterface = $voix.options.administration
const { buildMenus } = await useVoixMenus()
const availableMenus = await buildMenus(allMenus)
</script>

<template>
  <div class="pl-4">
    <div
      class="flex flex-col space-y-6 bg-gray-50 w-[280px] text-gray-900 text-xs py-4"
    >
      <div v-for="(adminMenu, key) in availableMenus" :key="key">
        <div
          class="w-full flex justify-between items-center text-2xs tracking-wide font-semibold uppercase voix-admin-text-dark border-b border-gray-300 pb-1  px-4"
        >
          {{ adminMenu.label }}
        </div>
        <ul class="mt-2">
          <li v-for="(adminMenuLink, linkKey) in adminMenu.links" :key="linkKey">
            <NuxtLink
              class="w-full flex items-center py-2 px-4 transition-colors duration-200 border-y border-transparent hover:bg-gray-100 hover:voix-admin-border-lightest voix-admin-text-dark"
              :to="adminMenuLink.to"
            >
              {{ adminMenuLink.label }}
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
